<div class="product-supplement" data-test="product-supplement">
  <ng-container *ngIf="isValid === false">
    <div class="product-supplement__error notification notification-error text--input-small" data-test="product-supplement__input-error">
      <mat-icon>error</mat-icon>
      {{ 'product.wizard.supplement.tab-title' | translate }}
    </div>
  </ng-container>

  <ng-container *ngIf="variants$ | async as variants">
    <div class="product-supplement__subtitle">
      {{ 'product.wizard.supplement.description' | translate }}
    </div>
    <div class="product-supplement__stats flex--row flex--gutter flex--align-center spacing--margin-vertical">
      <div class="product-supplement__percent flex__child">
        <div class="text--label">{{ 'product.wizard.supplement.product' | translate }}</div>
        <div>
          {{ lineItem?.title }}
        </div>
      </div>
      <div class="product-supplement__promille flex__child">
        <div class="text--label">{{ 'product.wizard.supplement.code' | translate }}</div>
        <div>
          {{ lineItem?.id }}
        </div>
      </div>
      <div class="product-supplement__weight flex__child">
        <div class="text--label">{{ 'product.wizard.supplement.weight' | translate }}</div>
        <div>
          {{ lineItem?.quantity }}
          {{ 'unit.' + lineItem?.orderUnit | translate }}
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div class="spacing--margin-all" *ngFor="let entry of productSupplementsFormArray.controls; let isFirst = first; let index = index">
      <app-product-supplement-item
        [entry]="entry"
        [index]="index"
        [selectedSkuLine]="lineItem"
        (removeSupplementEvent)="removeEntry($event)"
        (disableAddEvent)="isAddBtnDisabled = $event"
      >
      </app-product-supplement-item>
    </div>

    <div class="spacing--margin-vertical">
      <button mat-button color="primary" (click)="addEntry()" data-test="product-supplement__add" [disabled]="isAddBtnDisabled">
        <mat-icon>add</mat-icon>{{ 'product.wizard.supplement.supplement' | translate }}
      </button>
    </div>
  </ng-container>

  <div
    class="product-supplement__loading flex--row flex--justify-center flex--align-center spacing--margin-vertical"
    data-test="product-supplement__loading"
    *ngIf="(variantsLoaded$ | async) !== true && (variantsNotAvailable$ | async) !== true"
  >
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div
    class="product-supplement__warning notification notification-warning text--input-small"
    data-test="product-supplement__no-variants-warning"
    *ngIf="(variantsNotAvailable$ | async) === true"
  >
    <mat-icon>warning</mat-icon>
    {{ 'product.wizard.supplement.no-variants-available' | translate }}
  </div>
</div>
